import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Card, Select, LogoLoader } from "../../../components/ui";

const DepositWithdrawChart = ({
  donutMonth,
  setDonutMonth,
  donutYear,
  setDonutYear,
  pieData,
  depositsVal,
  depositsPct,
  withdrawalsVal,
  withdrawalsPct,
  totalVal,
  isDonutLoading,
  CustomTooltip,
  isAllZero
}) => {
  return (
    <Card className="lg:col-span-1 flex flex-col justify-between">
      <Card.Header
        title="Deposits vs Withdrawals"
        actions={
          <div className="flex items-center gap-2">
            <Select
              value={donutMonth}
              onChange={(e) => setDonutMonth(e.target.value)}
              options={[
                { value: "all", label: "Last 90 Days" },
                { value: "01", label: "January" },
                { value: "02", label: "February" },
                { value: "03", label: "March" },
                { value: "04", label: "April" },
                { value: "05", label: "May" },
                { value: "06", label: "June" },
                { value: "07", label: "July" },
                { value: "08", label: "August" },
                { value: "09", label: "September" },
                { value: "10", label: "October" },
                { value: "11", label: "November" },
                { value: "12", label: "December" },
              ]}
            />
            {donutMonth !== "all" && (
              <Select
                value={donutYear}
                onChange={(e) => setDonutYear(e.target.value)}
                options={[
                  { value: "2026", label: "2026" },
                  { value: "2025", label: "2025" },
                  { value: "2024", label: "2024" },
                ]}
              />
            )}
          </div>
        }
      />
      <Card.Body className="relative flex-1 flex flex-col justify-between min-h-[280px]">
        {isDonutLoading && (
          <div className="absolute inset-0 bg-white/70 backdrop-blur-xs flex items-center justify-center z-10">
            <LogoLoader size="sm" />
          </div>
        )}

        <div className="flex flex-row items-center justify-center gap-8 py-4">
          <div className="w-[160px] h-[160px] flex-shrink-0 flex items-center justify-center">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={pieData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={70}
                  paddingAngle={isAllZero ? 0 : 2}
                >
                  {pieData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={index === 0 ? "var(--color-primary-500)" : "var(--color-danger)"}
                      stroke="white"
                      strokeWidth={2}
                    />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="flex flex-col justify-center gap-4 pl-6 border-l border-border/50 min-w-0">
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-full bg-primary-500 inline-block" />
                <span className="text-xs font-semibold text-ink-500">Deposits</span>
              </div>
              <span className="text-xs font-bold text-ink-900 pl-5 whitespace-nowrap">
                ₹{depositsVal.toLocaleString("en-IN")} ({depositsPct}%)
              </span>
            </div>  
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-full bg-danger-500 inline-block" />
                <span className="text-xs font-semibold text-ink-500">Withdrawals</span>
              </div>
              <span className="text-xs font-bold text-ink-900 pl-5 whitespace-nowrap">
                ₹{withdrawalsVal.toLocaleString("en-IN")} ({withdrawalsPct}%)
              </span>
            </div>
          </div>
        </div>

        <div className="mt-4 bg-canvas p-2.5 rounded-lg border border-border text-center">
          <p className="text-ink-900 text-sm font-bold m-0">
            Total: ₹{totalVal.toLocaleString("en-IN")}
          </p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DepositWithdrawChart;
